import React, { useEffect, useState } from 'react';
import { Sidebar } from 'primereact/sidebar';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import '../../admission/resultsCapture/StyleHistorialPatient.css'
export const PatientHistoryCapture = ({
    selectedExam,
    visibleSidebar,
    setVisibleSidebar,
    loadingHistorico,
    historicoRaw,
    getNimsData,
    historicoData,
    renderHeaderNim,
    showResistanceView,
    setShowResistanceView

}) => {



    return (
        <Sidebar
            key={selectedExam?.id_exam || "empty"}
            visible={visibleSidebar}
            position="right"
            onHide={() => setVisibleSidebar(false)}
            className="sidebar-historico"
            style={{ width: '45%' }}
            maskClassName="mask-historico"

        >

            {
                loadingHistorico ? (
                    <div className="loader-container">
                        <div className="spinner"></div>
                        <p>Cargando histórico...</p>
                    </div>
                ) :
                    !historicoRaw ? null :
                        (() => {

                            const exam = historicoRaw.exams.find(e => e.id_exam === selectedExam?.id_exam);

                            if (!exam) return null;

                            const orders = getNimsData(historicoRaw, exam);
                            console.log("🧁 historicoRaw", historicoRaw);
                            console.log("SI SE HIZO EL CAMBIO")

                            const hasResistanceData = (exam?.antibiograms || []).some(abg =>
                                (abg?.bacteriums || []).some(b =>
                                    (b?.antibiotics?.length > 0) ||
                                    (b?.resistance_mechanisms?.length > 0) ||
                                    b?.label_mic_bacterium
                                )
                            );

                            const hasLargeMechanism = (exam?.antibiograms || []).some(abg =>
                                (abg?.bacteriums || []).some(b =>
                                    (b?.resistance_mechanisms || [])
                                        .map(x => x.resistance_mechanism)
                                        .join(" ")
                                        .length > 60
                                )
                            );

                            const getGroupedAntibiotics = (bacterium) => {

                            const grouped = {
                                sensible: [],
                                resistente: [],
                                intermedio: []
                            };

                            (bacterium.summary_antibiotics || []).forEach(group => {

                                const result =
                                    group.label_antibiotic_bacterium_result;

                                const antibiotics =
                                    group.antibiotics || [];

                                if (result === "Sensible") {

                                    grouped.sensible = antibiotics;

                                }

                                if (result === "Resistente") {

                                    grouped.resistente = antibiotics;

                                }

                                if (result === "Intermedio") {

                                    grouped.intermedio = antibiotics;

                                }

                            });

                            return grouped;
                        };
                            // DESCOMENTAR SI SE QUIERE LA PRIMERA VERSIÓN DE LOS ANTIBIOTICOS DE LOS PUNTOS (FORMA MATRIZ)

                            // const buildResistanceRows = () => {
                            //     const rows = [];

                            //     for (const abg of (exam?.antibiograms || [])) {

                            //         const order =
                            //             orders.find(
                            //                 x => x.id_work_order === abg.id_work_order
                            //             );

                            //         if (!order) continue;

                            //         for (const b of (abg?.bacteriums || [])) {

                            //             const micro =
                            //                 b.label_mic_bacterium || "-";

                            //             const mechanisms =
                            //                 b.resistance_mechanisms || [];

                            //             const antibiotics =
                            //                 b.antibiotics || [];
                                            

                            //             for (const a of antibiotics) {

                            //                 let row =
                            //                     rows.find(
                            //                         x => x.antibiotico === a.mic_antibiotic
                            //                     );

                            //                 if (!row) {

                            //                     row = {
                            //                         antibiotico:
                            //                             a.mic_antibiotic,

                            //                         cells: {}
                            //                     };

                            //                     rows.push(row);

                            //                 }

                            //                 const key =
                            //                     `${order.nim}_${micro}`;

                            //                 if (!row.cells[key]) {

                            //                     row.cells[key] = [];

                            //                 }

                            //                 if(mechanisms.length){

                            //                     mechanisms.forEach(m=>{

                            //                         row.cells[key].push({

                            //                             mecanismo:m.resistance_mechanism,

                            //                             resultado:
                            //                             a.label_antibiotic_bacterium_result
                            //                             || a.cim
                            //                             || "-"

                            //                         });

                            //                     });

                            //                 }else{

                            //                     row.cells[key].push({

                            //                         mecanismo:"-",

                            //                         resultado:
                            //                         a.label_antibiotic_bacterium_result
                            //                         || a.cim
                            //                         || "-"

                            //                     });

                            //                 }

                            //             }

                            //         }

                            //     }
                            //     return rows.filter(row =>

                            //         Object.values(row.cells).some(cells =>

                            //             cells?.some(
                            //                 x =>
                            //                     x.resultado === "Sensible" ||
                            //                     x.resultado === "Resistente" ||
                            //                     x.resultado === "Intermedio"
                            //             )

                            //         )

                            //     );

                            // }
                            return (
                                <>

                                    <div className="historico-header">

                                        <div className="header-left">
                                            <div className="icon-box">
                                                <i className="pi pi-info-circle"></i>
                                            </div>

                                            <div className="exam-name">
                                                {selectedExam?.name}
                                            </div>
                                        </div>

                                        <div className="header-actions">

                                            {
                                                showResistanceView && (
                                                    <button
                                                        className="btn-back-header"
                                                        onClick={() => setShowResistanceView(false)}
                                                    >
                                                        <i className="pi pi-arrow-left mr-1"></i>
                                                        Volver
                                                    </button>
                                                )
                                            }

                                            <div
                                                className="close-btn"
                                                onClick={() => setVisibleSidebar(false)}
                                            >
                                                ✕
                                            </div>

                                        </div>

                                    </div>

                                    <div className="flip-container">

                                        <div className={`flip-card ${showResistanceView ? "flipped" : ""}`}>

                                            <div className="flip-face front">

                                                <div className="historico-card mt-2">
                                                    {
                                                        orders.length === 0 ? (
                                                            <div
                                                                style={{
                                                                    padding: "20px",
                                                                    textAlign: "center",
                                                                    color: "#6b7280",
                                                                    fontWeight: "500"
                                                                }}
                                                            >
                                                                Sin resultados para este examen
                                                            </div>
                                                        ) : (

                                                            <DataTable
                                                                value={historicoData}
                                                                key={selectedExam?.id_exam}
                                                                scrollable
                                                                scrollDirection="horizontal"
                                                                className="table-historico"
                                                                scrollHeight="flex"
                                                                rowClassName={(row) => {
                                                                    if (row.tipo === "separador_micro") return "row-separador-micro";
                                                                    if (row.tipo === "antibiograma") return "row-antibiograma";

                                                                    if (row.tipo === "bacteria") return "row-bacteria";
                                                                    if (row.tipo === "header") return "row-header";

                                                                    const isChange = Object.keys(row).some(key => {
                                                                        if (!key.startsWith("nim_")) return false;

                                                                        const index = parseInt(key.split("_")[1]);
                                                                        const value = row[`nim_${index}`];
                                                                        const prev = row[`nim_${index + 1}`];

                                                                        return (
                                                                            value !== prev &&
                                                                            prev !== undefined &&
                                                                            value !== "-" &&
                                                                            prev !== "-"
                                                                        );
                                                                    });

                                                                    return isChange ? "row-cambio" : "";
                                                                }}
                                                            >

                                                                {/* 
                                                            })*/}
                                                                <Column
                                                                    header="ANALITO"
                                                                    frozen
                                                                    alignFrozen="left"
                                                                    style={{ minWidth: "125px", width: "155px" }}
                                                                    headerClassName="th-left"
                                                                    body={(row) => {

                                                                        if (row.tipo === "separador_micro") {

                                                                            return (
                                                                                <div className="micro-bar">
                                                                                    <span className='mr-3'>
                                                                                        {row.analito}
                                                                                    </span>
                                                                                    {
                                                                                        hasResistanceData && (
                                                                                            <button
                                                                                                className="btn-resistance-inline"
                                                                                                onClick={() => setShowResistanceView(true)}
                                                                                            >
                                                                                                Antibioticos
                                                                                            </button>
                                                                                        )
                                                                                    }

                                                                                </div>

                                                                            );

                                                                        }

                                                                        return (
                                                                            <span className="analito-cell">
                                                                                {row.analito}
                                                                            </span>
                                                                        );
                                                                    }}

                                                                />

                                                                {
                                                                    orders.map((order, index) => (
                                                                        <Column
                                                                            key={order.id_work_order}
                                                                            header={renderHeaderNim( order.nim, order.created_at_text)}
                                                                            body={(row) => {

                                                                                const value = row[`nim_${index}`];
                                                                                if (row.tipo === "separador_micro") return null;

                                                                                if (row.tipo === "antibiograma") {

                                                                                    if (row.tipo === "antibiograma") {

                                                                                        if (!value || !value.bacterias || value.bacterias.length === 0) {
                                                                                            return <span className="value-cell-antibiagram">-</span>;
                                                                                        }

                                                                                        return (
                                                                                            <div className="cell-antibiograma">

                                                                                                <div className="abg-cards-container">

                                                                                                    {
                                                                                                        value.bacterias.map((b, i) => (
                                                                                                            <div key={i} className="abg-card">

                                                                                                                <div className="abg-card-header">
                                                                                                                    {b.label_mic_bacterium || "-"}
                                                                                                                </div>

                                                                                                                <div className="abg-card-body">

                                                                                                                    {/* <div className="abg-item">
                                                                                                                        <span className="abg-label">Gram:</span>
                                                                                                                        <span className={
                                                                                                                            b.label_mic_stain_gram === "POSITIVO"
                                                                                                                                ? "gram-positive"
                                                                                                                                : b.label_mic_stain_gram === "NEGATIVO"
                                                                                                                                    ? "gram-negative"
                                                                                                                                    : ""
                                                                                                                        }>
                                                                                                                            {b.label_mic_stain_gram || "-"}
                                                                                                                        </span>
                                                                                                                    </div> */}

                                                                                                                    <div className="abg-item">

                                                                                                                        <span className="abg-label">
                                                                                                                            Mecanismo de Resistencia:
                                                                                                                        </span>

                                                                                                                        <div className="mechanism-container">

                                                                                                                            {
                                                                                                                                b.resistance_mechanisms?.length
                                                                                                                                    ? b.resistance_mechanisms.map((m, index) => (

                                                                                                                                        <span
                                                                                                                                            key={index}
                                                                                                                                            className="mechanism-chip"
                                                                                                                                        >
                                                                                                                                            {m.resistance_mechanism}
                                                                                                                                        </span>

                                                                                                                                    ))
                                                                                                                                    : (
                                                                                                                                        <span className="mechanism-empty">
                                                                                                                                            -
                                                                                                                                        </span>
                                                                                                                                    )
                                                                                                                            }

                                                                                                                        </div>

                                                                                                                    </div>

                                                                                                                    <div className="abg-item">
                                                                                                                        <span className="abg-label">
                                                                                                                            Cantidad númerica:
                                                                                                                        </span>

                                                                                                                        <span className="abg-result-number">
                                                                                                                            {b.quantity_number || "-"}
                                                                                                                        </span>
                                                                                                                    </div>

                                                                                                                    <div className="abg-item">
                                                                                                                        <span className="abg-label">
                                                                                                                            Cantidad texto:
                                                                                                                        </span>

                                                                                                                        <span className="abg-result-text">
                                                                                                                            {b.label_bacterium_count_text || "-"}
                                                                                                                        </span>
                                                                                                                    </div>
                                                                                                                    {/* Descomentar si un cliente lo quiere en su historico en microclinica */}

                                                                                                                    {/* <div className="abg-item">
                                                                                                                            <span className="abg-label">Comentario:</span>
                                                                                                                            <div className="abg-comment">
                                                                                                                                {b.comment_resistance_mechanism || "-"}
                                                                                                                            </div>
                                                                                                                        </div> 
                                                                                                                    */}


                                                                                                                </div>

                                                                                                            </div>
                                                                                                        ))
                                                                                                    }

                                                                                                </div>

                                                                                            </div>
                                                                                        );
                                                                                    }
                                                                                }

                                                                                const prev = row[`nim_${index + 1}`];

                                                                                const changed =
                                                                                    value !== prev &&
                                                                                    prev !== undefined &&
                                                                                    value !== "-" &&
                                                                                    prev !== "-";

                                                                                return (
                                                                                    <span className={`value-cell ${changed ? 'danger' : ''}`}>
                                                                                        {value}
                                                                                    </span>
                                                                                );
                                                                            }}
                                                                        />
                                                                    ))
                                                                }

                                                            </DataTable>
                                                        )}

                                                </div>

                                            </div>


                                            {/* CARA TRASERA */}

                                            <div className="flip-face back">
                                                <div className="historico-card resistance-table-container container-global-zoom">
                                                    <div className={`custom-resistance-table ${
                                                        hasLargeMechanism ? "large-mechanism" : ""
                                                    }`}>

                                                        <table>

                                                            <thead>

                                                                <tr>

                                                                    <th className="sticky-antibiotic-header">
                                                                        NIM
                                                                    </th>

                                                                    {

                                                                        orders.map(order => {

                                                                            const bacterias =
                                                                                (exam.antibiograms || [])

                                                                                    .filter(
                                                                                        x => x.id_work_order === order.id_work_order
                                                                                    )

                                                                                    .flatMap(
                                                                                        x => x.bacteriums || []
                                                                                    );

                                                                            return (

                                                                                <th
                                                                                    key={order.id_work_order}
                                                                                    colSpan={Math.max(bacterias.length * 3,3)}
                                                                                    className="nim-divider"
                                                                                >
                                                                                    {order.nim}
                                                                                    <br />
                                                                                    {order.created_at_text}
                                                                                </th>

                                                                            )

                                                                        })

                                                                    }

                                                                </tr>


                                                                {/* microorganismo */}

                                                                <tr>

                                                                    <th className="sticky-left-title">
                                                                        MICROORGANISMO
                                                                    </th>

                                                                    {

                                                                        orders.flatMap(order => {

                                                                            const bacterias =
                                                                                (exam.antibiograms || [])

                                                                                    .filter(
                                                                                        x => x.id_work_order === order.id_work_order
                                                                                    )

                                                                                    .flatMap(
                                                                                        x => x.bacteriums || []
                                                                                    );

                                                                            if (!bacterias.length) {

                                                                                return (

                                                                                    <th
                                                                                        colSpan="3"
                                                                                        className="empty-header"
                                                                                    >

                                                                                        <span className="empty-pill">

                                                                                            Sin resultados ingresados

                                                                                        </span>

                                                                                    </th>

                                                                                )

                                                                            }

                                                                            return bacterias.map((b, i) => (

                                                                                <th
                                                                                    key={`micro-${i}`}
                                                                                    colSpan="3"
                                                                                    className="micro-header"
                                                                                >

                                                                                    {b.label_mic_bacterium || "-"}

                                                                                </th>

                                                                            ))

                                                                        })

                                                                    }

                                                                </tr>

                                                                {/* mecanismo */}
                                                                <tr>

                                                                    <th className="sticky-left-title">

                                                                        MECANISMO DE RESISTENCIA

                                                                    </th>

                                                                    {

                                                                        orders.flatMap(order => {

                                                                            const bacterias =
                                                                                (exam.antibiograms || [])

                                                                                    .filter(
                                                                                        x => x.id_work_order === order.id_work_order
                                                                                    )

                                                                                    .flatMap(
                                                                                        x => x.bacteriums || []
                                                                                    );


                                                                            if (!bacterias.length) {

                                                                                return (

                                                                                    <th
                                                                                        colSpan="3"
                                                                                        className="mechanism-header mechanism-empty"
                                                                                    >

                                                                                        <span className="empty-pill">

                                                                                            Sin resultados ingresados

                                                                                        </span>

                                                                                    </th>

                                                                                )

                                                                            }

                                                                            return bacterias.map((b, i) => (

                                                                                <th
                                                                                    key={i}
                                                                                    colSpan="3"
                                                                                    className="mechanism-header"
                                                                                >

                                                                                    {
                                                                                        b.resistance_mechanisms
                                                                                            ?.map(
                                                                                                x => x.resistance_mechanism
                                                                                            )
                                                                                            .join(", ")

                                                                                        ||

                                                                                        "-"
                                                                                    }

                                                                                </th>

                                                                            ))

                                                                        })

                                                                    }

                                                                </tr>

                                                                {/* <tr>

                                                                    <th className="sticky-left-title">

                                                                        INTERPRETACIÓN

                                                                    </th>

                                                                    {

                                                                        orders.flatMap(order => {

                                                                            const bacterias =
                                                                                (exam.antibiograms || [])

                                                                                    .filter(
                                                                                        x => x.id_work_order === order.id_work_order
                                                                                    )

                                                                                    .flatMap(
                                                                                        x => x.bacteriums || []
                                                                                    );

                                                                            if (!bacterias.length) {

                                                                                return (

                                                                                    <th
                                                                                        colSpan="3"
                                                                                        className="empty-header"
                                                                                    >

                                                                                        <span className="empty-pill">

                                                                                            Sin resultados ingresados

                                                                                        </span>

                                                                                    </th>

                                                                                )

                                                                            }

                                                                            return bacterias.map((b, i) => (

                                                                                <React.Fragment key={i}>

                                                                                   <th className="sir-header sir-s">
                                                                                        S
                                                                                    </th>

                                                                                    <th className="sir-header sir-r">
                                                                                        R
                                                                                    </th>

                                                                                    <th className="sir-header sir-i">
                                                                                        I
                                                                                    </th>

                                                                                </React.Fragment>

                                                                            ))

                                                                        })

                                                                    }

                                                                </tr> */}

                                                            </thead>
                                                            {/* DESCOMENTAR SI SE QUIERE LA PRIMERA VERSIÓN DE LOS ANTIBIOTICOS EN FORMA DE MATRIZ */}

                                                            {/* <tbody>

                                                                {

                                                                    buildResistanceRows().map((row, index) => (

                                                                        <tr key={index}>

                                                                            <td className="antibiotic-name">

                                                                                {row.antibiotico}

                                                                            </td>

                                                                            {

                                                                            orders.flatMap(order => {

                                                                                const bacterias =
                                                                                    (exam.antibiograms || [])
                                                                                        .filter(x => x.id_work_order === order.id_work_order)
                                                                                        .flatMap(x => x.bacteriums || []);

                                                                                if (!bacterias.length) {

                                                                                    return (
                                                                                        <React.Fragment key={`empty-${order.id_work_order}`}>
                                                                                            <td className="sir-cell"></td>
                                                                                            <td className="sir-cell"></td>
                                                                                            <td className="sir-cell"></td>
                                                                                        </React.Fragment>
                                                                                    );
                                                                                }

                                                                                return bacterias.map((b, i) => {

                                                                                    const key =
                                                                                        `${order.nim}_${b.label_mic_bacterium}`;

                                                                                    const data =
                                                                                        row.cells[key];

                                                                                    return (
                                                                                        <React.Fragment key={`${order.id_work_order}-${i}`}>

                                                                                            <td className="sir-cell">
                                                                                                {
                                                                                                    data?.some(
                                                                                                        x => x.resultado === "Sensible"
                                                                                                    )
                                                                                                        ? <div className="dot dot-s" title='Sensible' style={{cursor: 'pointer'}}/>
                                                                                                        : ""
                                                                                                }
                                                                                            </td>

                                                                                            <td className="sir-cell">
                                                                                                {
                                                                                                    data?.some(
                                                                                                        x => x.resultado === "Resistente"
                                                                                                    )
                                                                                                        ? <div className="dot dot-r" title='Resistente' style={{cursor: 'pointer'}}/>
                                                                                                        : ""
                                                                                                }
                                                                                            </td>

                                                                                            <td className="sir-cell">
                                                                                                {
                                                                                                    data?.some(
                                                                                                        x => x.resultado === "Intermedio"
                                                                                                    )
                                                                                                        ? <div className="dot dot-i" title='Intermedio' style={{cursor: 'pointer'}} />
                                                                                                        : ""
                                                                                                }
                                                                                            </td>

                                                                                        </React.Fragment>
                                                                                    );
                                                                                });

                                                                            })

                                                                            }

                                                                        </tr>

                                                                    ))

                                                                }

                                                            </tbody> */}
                                                            <tbody>

                                                                <tr>

                                                                    <td className="antibiotic-name interpretation-main-title">

                                                                        INTERPRETACIÓN

                                                                    </td>

                                                                    {

                                                                        orders.flatMap(order => {

                                                                            const bacterias =
                                                                                (exam.antibiograms || [])

                                                                                    .filter(
                                                                                        x => x.id_work_order === order.id_work_order
                                                                                    )

                                                                                    .flatMap(
                                                                                        x => x.bacteriums || []
                                                                                    );

                                                                            if (!bacterias.length) {

                                                                                return (

                                                                                    <td
                                                                                        colSpan="3"
                                                                                        className="empty-interpretation"
                                                                                    >
                                                                                        -
                                                                                    </td>

                                                                                );

                                                                            }

                                                                            return bacterias.map((b, index) => {

                                                                                const grouped =
                                                                                    getGroupedAntibiotics(b);

                                                                                return (

                                                                                    <td
                                                                                        key={`${order.id_work_order}-${index}`}
                                                                                        colSpan="3"
                                                                                        className="interpretation-cell"
                                                                                    >

                                                                                        <div className="interpretation-wrapper">

                                                                                            {/* SENSIBLE */}
                                                                                            <div className="interpretation-card sensitive-card">

                                                                                                <div className="interpretation-title">

                                                                                                    Sensible

                                                                                                </div>

                                                                                                <div className="antibiotic-tags">

                                                                                                    {
                                                                                                        grouped.sensible.length
                                                                                                            ? grouped.sensible.map((a, i) => (
                                                                                                                <span
                                                                                                                    key={i}
                                                                                                                    className="tag-sensible"
                                                                                                                >
                                                                                                                    {a}
                                                                                                                </span>
                                                                                                            ))
                                                                                                            : "-"
                                                                                                    }

                                                                                                </div>

                                                                                            </div>

                                                                                            {/* RESISTENTE */}
                                                                                            <div className="interpretation-card resistant-card">

                                                                                                <div className="interpretation-title">

                                                                                                    Resistente

                                                                                                </div>

                                                                                                <div className="antibiotic-tags">

                                                                                                    {
                                                                                                        grouped.resistente.length
                                                                                                            ? grouped.resistente.map((a, i) => (
                                                                                                                <span
                                                                                                                    key={i}
                                                                                                                    className="tag-resistant"
                                                                                                                >
                                                                                                                    {a}
                                                                                                                </span>
                                                                                                            ))
                                                                                                            : "-"
                                                                                                    }

                                                                                                </div>

                                                                                            </div>

                                                                                            {/* INTERMEDIO */}
                                                                                            <div className="interpretation-card intermediate-card">

                                                                                                <div className="interpretation-title">

                                                                                                    Intermedio

                                                                                                </div>

                                                                                                <div className="antibiotic-tags">

                                                                                                    {
                                                                                                        grouped.intermedio.length
                                                                                                            ? grouped.intermedio.map((a, i) => (
                                                                                                                <span
                                                                                                                    key={i}
                                                                                                                    className="tag-intermediate"
                                                                                                                >
                                                                                                                    {a}
                                                                                                                </span>
                                                                                                            ))
                                                                                                            : "-"
                                                                                                    }

                                                                                                </div>

                                                                                            </div>

                                                                                        </div>

                                                                                    </td>

                                                                                );

                                                                            });

                                                                        })

                                                                    }

                                                                </tr>

                                                            </tbody>
                                                        </table>

                                                    </div>
                                                </div>
                                            </div>

                                        </div>

                                    </div>

                                </>

                            );
                        })()
            }

        </Sidebar>
    )
}